import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-ups-email-input',
    template: require('./ups-email-input.component.html')
})
export class UpsEmailInputComponent implements OnInit {

    @Input() emailValue: any;
    @Input() currentPosition: number;
    @Output() onRemoveEmailEvent = new EventEmitter<number>();

    constructor() { }

    ngOnInit() {}

    removeEmail() {
        this.onRemoveEmailEvent.emit(this.currentPosition);
    }

    onChange(newValue) {
        const validEmailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (validEmailRegEx.test(newValue)) {
            this.emailValue.isValid = true;
        } else {
            this.emailValue.isValid = false;
        }
    }

    public focusoutHandler(newValue: any) {
        const validEmailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!validEmailRegEx.test(newValue.target.value)) {
            this.emailValue.isValid = false;
        }
    }

}
